// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CgMvZ","title":"Info_title__3THPq","links":"Info_links__1OnpG","link":"Info_link__Hohje","logo":"Info_logo__xCYTA"};